import React, { useState, useEffect } from "react";
import GoogleAdSmall1 from "@/components/Ads/GoogleAdSmall1";
import GoogleAdSmall2 from "@/components/Ads/GoogleAdSmall2";
import GoogleAdSmall3 from "@/components/Ads/GoogleAdSmall3";
import GoogleAdSquare from "@/components/Ads/GoogleAdSquare";
import EventData from "../../data/events.json";
import Image from "next/image";
import Link from "next/link";
import CPAggregator from "@/models/CPAggregator";
import CPTagsAggregator from "@/models/CPTagsAggregator";

const EventSidebar = ({ events }) => {
  const [showMoreCategory, setShowMoreCategory] = useState(false);
  const [showMoreProvider, setShowMoreProvider] = useState(false);

  // extract list of Providers from the Event list (including count) then sort based on count-desc
  const providerAggregator = new CPAggregator(events, "provider")
  const providers = providerAggregator.list

  // extract list of Categories from the Event list (including count) then sort based on count-desc
  const categoryAggregator = new CPAggregator(events, "category")
  const categories = categoryAggregator.list

  // extract list of Tags from the Event list (including count) then sort based on count-desc
  const tagsAggregator = new CPTagsAggregator(events)
  const tags = tagsAggregator.list
  // console.log(tags)

  return (
    <>
      <aside className="rbt-sidebar-widget-wrapper rbt-gradient-border">
        {/* <div className="rbt-single-widget rbt-widget-search">
          <div className="inner">
            <form action="#" className="rbt-search-style-1">
              <input type="text" placeholder="Search Events" />
              <button className="search-btn">
                <i className="feather-search"></i>
              </button>
            </form>
          </div>
        </div> */}

        <div
          className={`rbt-single-widget rbt-widget-categories ${showMoreCategory ? "has-show-more" : ""}`}
        >
          <div className="inner">
            <h4 className="rbt-widget-title">Categories</h4>
            <ul className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content">
              {categories &&
                categories.map((data, index) => (
                  <li className="rbt-check-group" key={index}>
                    <input id={`category-${data.id}`} type="checkbox" name={`category-${data.id}`} />
                    <label htmlFor={`category-${data.id}`}>
                      {data.name}
                      <span className="rbt-lable count">{data.count}</span>
                    </label>
                  </li>
                ))}
            </ul>
          </div>
          <div
            className={`rbt-show-more-btn ${showMoreCategory ? "active" : ""}`}
            onClick={() => setShowMoreCategory(!showMoreCategory)}
          >
            {showMoreCategory ? "Show Less" : "Show More"}
          </div>
        </div>

        <GoogleAdSmall1 />

        <div
          className={`rbt-single-widget rbt-widget-categories has-show-more ${showMoreProvider ? "active" : ""
            }`}
        >
          <div className="inner">
            <h4 className="rbt-widget-title">Providers</h4>
            <ul className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content">
              {providers &&
                providers.map((data, index) => (
                  <li className="rbt-check-group" key={index}>
                    <input id={`provider-${data.id}`} type="checkbox" name={`provider-${data.id}`} />
                    <label htmlFor={`provider-${data.id}`}>
                      {data.name}
                      <span className="rbt-lable count">{data.count}</span>
                    </label>
                  </li>
                ))}
            </ul>
          </div>
          <div
            className={`rbt-show-more-btn ${showMoreProvider ? "active" : ""}`}
            onClick={() => setShowMoreProvider(!showMoreProvider)}
          >
            {showMoreProvider ? "Show Less" : "Show More"}
          </div>
        </div>

        <GoogleAdSmall2 />

        {/* <div className="rbt-single-widget rbt-widget-recent">
          <div className="inner">
            <h4 className="rbt-widget-title">Recent Events</h4>
            <ul className="rbt-sidebar-list-wrapper recent-post-list">
              {EventData &&
                EventData.events.slice(0, 4).map((data, index) => (
                  <li key={index}>
                    <div className="thumbnail">
                      <Link href={`/event/${data.id}`}>
                        <Image
                          src={data.img}
                          width={241}
                          height={163}
                          alt="Event Images"
                        />
                      </Link>
                    </div>
                    <div className="content">
                      <h6 className="title">
                        <Link href={`/event/${data.id}`}>
                          {data.title}
                        </Link>
                      </h6>
                      <ul className="rbt-meta">
                        <li>
                          <i className="feather-clock"></i>
                          {data.time}
                        </li>
                      </ul>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <GoogleAdSmall3 /> */}

        <div className="rbt-single-widget rbt-widget-tag">
          <div className="inner">
            <h4 className="rbt-widget-title">Tags</h4>
            <div className="rbt-sidebar-list-wrapper rbt-tag-list">
              {tags &&
                tags.map((tag) => (
                  <Link key={tag.id} href="#">
                    {tag.name}
                  </Link>
                ))}
            </div>
          </div>
        </div>

        <GoogleAdSquare />

      </aside>
    </>
  );
};

export default EventSidebar;
